export const CHILD: {
    [s: string]: string;
} = {
    1: '子供なし',
    2: '子供あり'
};